import { useMutation as r } from "@apollo/client";
import u from "../../graphql/mutation/logout.js";
import { useState as c, useCallback as i } from "react";
const l = (t) => t, d = () => {
  const [t, { loading: o }] = r(u), [e, a] = c(!1);
  return {
    mutate: i(async () => {
      const n = await t(), s = l(n);
      return a(s), s;
    }, [t]),
    data: e,
    loading: o
  };
};
export {
  d as default
};
//# sourceMappingURL=useLogout.js.map
